export default __webpack_public_path__ + "static/media/941.4dee88e6.jpg";